import { useLayoutEffect } from 'react';

function readViewportHeight(): number {
  const visual = window.visualViewport;
  if (visual && visual.height > 0) {
    return Math.round(visual.height);
  }
  return window.innerHeight;
}

/**
 * Keeps --app-height in sync with the visual viewport.
 * Does not read visualViewport.offsetTop (that jumps the top banner when the
 * iOS URL bar moves). Used so the wallet shell matches first-paint height on
 * browsers without 100dvh and on Safari where 100vh is the large viewport.
 */
export function useAppViewportHeight(): void {
  useLayoutEffect(() => {
    const apply = () => {
      const height = readViewportHeight();
      if (height > 0) {
        document.documentElement.style.setProperty('--app-height', `${height}px`);
      }
    };

    apply();

    const visual = window.visualViewport;
    visual?.addEventListener('resize', apply);
    window.addEventListener('resize', apply);
    window.addEventListener('orientationchange', apply);

    return () => {
      visual?.removeEventListener('resize', apply);
      window.removeEventListener('resize', apply);
      window.removeEventListener('orientationchange', apply);
    };
  }, []);
}
